import React from "react";
import { AUTH } from "@/constants/testIds";

// Admin (founders-only) login screen — Google allow-list gated.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const handleLogin = () => {
    sessionStorage.setItem("watuwako:mode", "admin");
    sessionStorage.setItem("watuwako:next", "/admin/queue");
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--bg-cream)" }}>
      <div className="w-full max-w-md rounded-2xl border p-10" style={{ borderColor: "var(--line-cream)", background: "var(--card-cream)" }}>
        <p className="eyebrow" style={{ color: "var(--text-muted-cream)" }}>watu wako · admin</p>
        <h1 className="font-display mt-2 text-3xl font-bold">Founder review desk</h1>
        <p className="mt-2 text-sm" style={{ color: "var(--text-muted-cream)" }}>
          Google sign-in — restricted to the allow-list. Members: use the <a href="/join" className="underline">public sign-in</a>.
        </p>

        <button
          data-testid={AUTH.loginGoogleButton}
          onClick={handleLogin}
          className="mt-8 flex w-full items-center justify-center gap-3 rounded-full px-6 py-3 text-sm font-semibold text-white transition-colors hover:opacity-90"
          style={{ background: "#211D14" }}
        >
          <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden>
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
          </svg>
          Continue with Google
        </button>

        <p className="mt-6 text-xs" style={{ color: "var(--text-dim-cream)" }}>
          Only <code>nyamburavania@gmail.com</code>, <code>hello@watuwako.com</code> and <code>admin@watuwako.com</code> can proceed to the review desk.
        </p>
      </div>
    </div>
  );
}
